import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetAll(order) {
  const isFast = window.location.search.indexOf('fast') !== -1;
  const common = React.useCallback(
    o => ({ params: { ...(isFast ? { fast: true } : {}), order: o } }),
    [isFast],
  );

  const [state, q] = useAxios({
    url: '/api/v1/contributors',
    method: 'GET',
    ...common(order),
  }, { manual: true });

  const executeQuery = React.useCallback(o => q(common(o)), [q, common]);

  return [state, executeQuery];
}
